  <div class="employment-information-form">
    <div class="signio-divider-header" @click="toggle('status_details')">
      <span class="chevron">{{ collapsed_sections.status_details ? '▸' : '▾' }}</span>
      <label class="signio-divider-header-title">Employment Status & Employer</label>
    </div>
    <transition name="fade">
      <div v-show="!collapsed_sections.status_details">
        <div class="form-group my-2">
          <label for="customer-employment-status" class="text-xs required">Employment status?</label>
          <select id="customer-employment-status" class="form-select" v-model="form_data.customerEmploymentStatus" required>
            <option v-for="(option, index) in employment_status_options" :key="index" :value="option">{{ option }}</option>
          </select>
        </div>
        <div v-if="show_additional_sections" class="form-group my-2">
          <label for="employer-name" class="text-xs">Employer Name? (Please capture exactly as per payslip)</label>
          <input type="text" id="employer-name" class="form-control" v-model="form_data.employerName" placeholder="Enter employer name" />
        </div>
      </div>
    </transition>

    <div v-if="show_additional_sections" class="signio-divider-header mt-4" @click="toggle('occupation_details')">
      <span class="chevron">{{ collapsed_sections.occupation_details ? '▸' : '▾' }}</span>
      <label class="signio-divider-header-title">Occupation & Industry</label>
    </div>
    <transition name="fade" v-if="show_additional_sections">
      <div v-show="!collapsed_sections.occupation_details">
        <div class="form-group my-2">
          <label for="customer-occupation" class="text-xs">Occupation?</label>
          <select id="customer-occupation" class="form-select" v-model="form_data.customerOccupation">
            <option v-for="(option, index) in occupation_options" :key="index" :value="option">{{ option }}</option>
          </select>
        </div>
        <div class="form-group my-2">
          <label for="employer-industry-type" class="text-xs">Employer's industry type?</label>
          <select id="employer-industry-type" class="form-select" v-model="form_data.employerIndustryType">
            <option v-for="(option, index) in industry_type_options" :key="index" :value="option">{{ option }}</option>
          </select>
        </div>
        <div class="form-group my-2">
          <label for="employment-level" class="text-xs">Employment level?</label>
          <select id="employment-level" class="form-select" v-model="form_data.employmentLevel">
            <option v-for="(option, index) in employment_level_options" :key="index" :value="option">{{ option }}</option>
          </select>
        </div>
        <div class="form-group my-2">
          <label for="retrenchment-notification" class="text-xs">In the last 6 months, have you received an S189 Retrenchment Notification from your employer?</label>
          <select id="retrenchment-notification" class="form-select" v-model="form_data.RetrenchmentNotifyInd">
            <option value="Not Selected">Not Selected</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
      </div>
    </transition>

    <div v-if="show_additional_sections" class="signio-divider-header mt-4" @click="toggle('address_details')">
      <span class="chevron">{{ collapsed_sections.address_details ? '▸' : '▾' }}</span>
      <label class="signio-divider-header-title">Employer Address</label>
    </div>
    <transition name="fade" v-if="show_additional_sections">
      <div v-show="!collapsed_sections.address_details">
        <div class="form-group my-2">
          <label for="employer-address-line1" class="text-xs required">Employer's address line 1?</label>
          <input type="text" id="employer-address-line1" class="form-control" v-model="form_data.employerAddressLine1" placeholder="Enter employer address line 1" required />
        </div>
        <div class="form-group my-2">
          <label for="employer-address-line2" class="text-xs">Employer's address line 2?</label>
          <input type="text" id="employer-address-line2" class="form-control" v-model="form_data.employerAddressLine2" placeholder="Enter employer address line 2" />
        </div>
        <div class="form-group my-2">
          <label for="employer-suburb" class="text-xs">Employer's suburb?</label>
          <input type="text" id="employer-suburb" class="form-control" v-model="form_data.employerSuburb" placeholder="Enter employer suburb" />
        </div>
        <div class="form-group my-2">
          <label for="employer-postal-code" class="text-xs">Employer's postal code?</label>
          <input type="text" id="employer-postal-code" class="form-control" v-model="form_data.employerPostalCode" placeholder="Enter employer postal code" />
        </div>
      </div>
    </transition>

    <div v-if="show_additional_sections || form_data.customerEmploymentStatus == 'Pensioner'" class="signio-divider-header mt-4" @click="toggle('period_details')">
      <span class="chevron">{{ collapsed_sections.period_details ? '▸' : '▾' }}</span>
      <label class="signio-divider-header-title">Employment History</label>
    </div>
    <transition name="fade" v-if="show_additional_sections || form_data.customerEmploymentStatus == 'Pensioner'">
      <div v-show="!collapsed_sections.period_details">
        <div class="form-group my-2" v-if="form_data.customerEmploymentStatus != 'Pensioner'">
          <label class="text-xs required">How long has the applicant been with the current employer?</label>
          <div class="d-flex">
            <input type="number" class="form-control me-2" v-model="form_data.customerPeriodAtCurrentEmployerYears" placeholder="Years" min="0" required />
            <input type="number" class="form-control" v-model="form_data.customerPeriodAtCurrentEmployerMonths" placeholder="Months" min="0" max="11" />
          </div>
        </div>
        <div class="form-group my-2">
          <label class="text-xs">How long was the applicant with the previous employer?</label>
          <div class="d-flex">
            <input type="number" class="form-control me-2" v-model="form_data.customerPeriodAtPreviousEmployerYears" placeholder="Years" min="0" />
            <input type="number" class="form-control" v-model="form_data.customerPeriodAtPreviousEmployerMonths" placeholder="Months" min="0" max="11" />
          </div>
        </div>
        
      </div>
    </transition>

    <div class="text-end mt-4">
      <button type="button" @click="previous" class="btn btn-bg-secondary text-xs rounded-small shadow-sm me-1">
        Previous
      </button>
      <button type="button" @click="submit_section" class="btn btn-bg-green text-xs rounded-small shadow-sm">
        Continue
      </button>
    </div>
  </div>